import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';

class ModuleCourseListService {
  fetch = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      courses: [],
      pagination: {
        current: 1,
        pageSize: 30,
        total: 0,
      },
    });
  }

  init = action(() => {
    this.courses = [];
    this.pagination = {
      ...this.pagination,
      current: 1,
    };
    this.load();
  });

  load = action(() => {
    this.fetch
      .fetch({
        url: '/courses?expand=academicPlan&expand=distributor',
        apiVersion: 'v2',
        query: {
          ...this.form.getValues(),
          page: this.pagination.current,
          size: this.pagination.pageSize,
          orderDirection: 'ascend',
          orderBy: 'order',
        },
      })
      .then(() => {
        if (this.fetch.data) {
          this.courses = this.fetch.data.docs;
          this.pagination = { ...this.pagination, total: this.fetch.data.total };

          if (this.fetch.data.total > this.pagination.pageSize) {
            this.pagination.pageSize = this.fetch.data.total;
            this.load();
          }
        } else {
          this.courses = [];
          this.pagination = { ...this.pagination, total: 0 };
        }
      });
  });
}

const moduleCourseListService = new ModuleCourseListService();

export default moduleCourseListService;
